// App.js
import React from 'react';
// Make sure Tailwind is imported

function Test() {
  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-lg p-6 h-[600px] w-full max-w-3xl ">
        
        <div className=" w-full h-full overflow-auto rounded-lg">
          <iframe 
            className=" w-full h-full  border-0"
            src="http://localhost:3000/video"
            title="Video Player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </div>
  );
}

export default Test;